<template>
  <ServiceCreateEditForm :service-id="serviceId" />
</template>

<script setup lang="ts">
defineProps<{
  serviceId: string
}>()
</script>
